import { render, staticRenderFns } from "./addModify-plan.vue?vue&type=template&id=38c3a844&scoped=true"
import script from "./addModify-plan.vue?vue&type=script&lang=js"
export * from "./addModify-plan.vue?vue&type=script&lang=js"
import style0 from "./addModify-plan.vue?vue&type=style&index=0&id=38c3a844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3a844",
  null
  
)

export default component.exports